const HedgingModeEnum = {
  Historical: 'Historical',
  MonteCarlo: 'MonteCarlo'
}

export default HedgingModeEnum
